import React from "react";
import { Link } from "react-router-dom";
import ProfilePopover from "./ProfilePopover";
import logo from "../assets/new-logo.png";
import tvEmoji from "../assets/tv-emoji.png";
import loudspeakerEmoji from "../assets/loud_speaker-emoji.png";
import "./DiscoverFeedHeader.css";

function DiscoverFeedHeader({ isStickyHeader }) {
  return (
    <header
      className={`discover-feed-header${isStickyHeader ? " discover-feed-header--compact" : ""}`}
      aria-label="Discover header"
    >
      <div className="discover-feed-header__left">
        <ProfilePopover />
      </div>

      <div className="discover-feed-header__logo">
        <Link to="/discover">
          <img src={logo} alt="Logo" className="discover-feed-header__logo-img" />
        </Link>
      </div>

      <div className="discover-feed-header__right">
        <Link
          to="/allplaylists"
          className="discover-feed-header__playlists-btn"
          title="Playlists"
        >
          <img src={tvEmoji} alt="" className="discover-feed-header__playlists-icon" />
          <img src={loudspeakerEmoji} alt="" className="discover-feed-header__playlists-icon" />
          <span className="discover-feed-header__playlists-text">Playlists</span>
        </Link>
      </div>
    </header>
  );
}

export default DiscoverFeedHeader;

